export const LOADING_OBJECTIVE_COMPETENCY_PILLAR = "LOADING_OBJECTIVE_COMPETENCY_PILLAR";
export const SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR = "SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR";
export const GET_OBJECTIVE_COMPETENCY_PILLAR = "GET_OBJECTIVE_COMPETENCY_PILLAR";
export const FORM_FAIL = "FORM_FAIL";
export const OBJECTIVE_COMPETENCY_PILLAR_FAIL = "OBJECTIVE_COMPETENCY_PILLAR_FAIL";
export const LOADING_OBJECTIVE_COMPETENCY_PILLAR_BY_ID = "LOADING_OBJECTIVE_COMPETENCY_PILLAR_BY_ID";
export const GET_OBJECTIVE_COMPETENCY_PILLAR_BY_ID = "GET_OBJECTIVE_COMPETENCY_PILLAR_BY_ID";

